import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import api from '@/lib/api';
import TourCard from '@/components/TourCard';
import { IDS } from '@/constants/testIds';

export default function FestivalTours() {
  const [tours, setTours] = useState([]);
  useEffect(() => {
    api.get('/tours', { params: { category: 'festival' } }).then((r) => setTours(r.data)).catch(() => {});
  }, []);

  return (
    <section id="festival" data-testid={IDS.sectionFestival} className="py-24 md:py-40 bg-espresso">
      <div className="container-x">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1] }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14 md:mb-20"
        >
          <div>
            <p className="overline mb-4">№ 02 · Festival Editions</p>
            <h2 className="font-serif-display text-5xl md:text-6xl lg:text-7xl leading-none max-w-2xl">
              Праздничные <em className="text-saffron">туры</em>
            </h2>
          </div>
          <p className="max-w-md text-foreground/70 text-base md:text-lg font-light">
            Даты, привязанные к главным праздникам Индии: Дивали, Холи, встреча Нового года у Ганга. Только для этих туров — скидка <span className="text-saffron">5%</span> при ранней брони.
          </p>
        </motion.div>

        {tours.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
            {/* First card featured wide */}
            {tours[0] && (
              <div className="md:col-span-12 lg:col-span-8">
                <TourCard tour={tours[0]} variant="wide" index={0} />
              </div>
            )}
            {tours[1] && (
              <div className="md:col-span-6 lg:col-span-4">
                <TourCard tour={tours[1]} index={1} />
              </div>
            )}
            {tours.slice(2).map((t, i) => (
              <div key={t.slug} className="md:col-span-6 lg:col-span-4">
                <TourCard tour={t} index={i + 2} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
